import React, { useState, useEffect } from 'react';
import { FaArrowUp, FaArrowDown, FaSync } from 'react-icons/fa';
export default function ProductTable({
    data_acount,
    set_data_acount,
    nutxuly,
    muahang,
    account_edits,
    idservice,
    dasaochep,
    mode
}) {
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

    const getIcon = (colKey) => {
        // Nếu chưa sort cột này, hiển thị FaSync (màu xám) ngay từ đầu
        if (sortConfig.key !== colKey) {
            return <FaSync className="inline ml-1 text-xs text-gray-300" />;
        }
        // Nếu đã sort rồi thì hiển thị mũi tên tăng/giảm
        return sortConfig.direction === 'ascending'
            ? <FaArrowUp className="inline ml-1 text-xs" />
            : <FaArrowDown className="inline ml-1 text-xs" />;
    };
    const onSort = (key) => {
        // Mặc định lần đầu nhấn là descending (cao → thấp)
        let direction = 'descending';
        // Nếu đang sort trên cùng 1 cột và đang là descending, thì chuyển thành ascending
        if (sortConfig.key === key && sortConfig.direction === 'descending') {
            direction = 'ascending';
        }
        setSortConfig({ key, direction });

        const sorted = [...data_acount].sort((a, b) => {
            const aVal = key === 'price' ? parseFloat(a[key]) : Number(a[key]);
            const bVal = key === 'price' ? parseFloat(b[key]) : Number(b[key]);
            if (aVal < bVal) return direction === 'ascending' ? -1 : 1;
            if (aVal > bVal) return direction === 'ascending' ? 1 : -1;
            return 0;
        });

        set_data_acount(sorted);
    };
    return (
        <table className="mt-1 table-fixed relative w-full border border-separate text-break text-sm">
            <thead className="bg-blue-500 text-white">
                <tr>
                    <th className="py-3 px-2" style={{ width: '27%' }}>
                        Tên sản phẩm
                    </th>
                    <th
                        className="py-3 px-2 text-left cursor-pointer select-none"
                        style={{ width: '12%' }}
                        onClick={() => onSort('price')}
                    >
                        Giá{getIcon('price')}
                    </th>
                    <th
                        className="py-3 px-2 cursor-pointer select-none"
                        style={{ width: '12%' }}
                        onClick={() => onSort('amount')}
                    >
                        Hiện có{getIcon('amount')}
                    </th>
                    <th className="py-3 px-2 text-left" style={{ width: '50%' }}>
                        Mô tả
                    </th>
                </tr>
            </thead>

            <tbody>
                {data_acount && data_acount.map(item_account => (
                    <tr
                        key={item_account.id}
                        className="bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 lg:text-black"
                    >
                        <td className="py-3 px-2 font-medium capitalize">{item_account.name}</td>
                        <td className="py-3 px-2">{item_account.price}</td>
                        <td className="py-3 px-2">{item_account.amount}</td>
                        <td className="py-3 px-2">

                            <div id={item_account.id}>
                                <div dangerouslySetInnerHTML={{ __html: item_account.description }} />
                                <div className="float-right">
                                    {mode == 'orders' && (
                                        <button
                                            disabled={nutxuly === 1}
                                            onClick={() => muahang(item_account.id)}
                                            className="text-xs flex font-medium rounded-full px-4 py-2 space-x-1 bg-white text-black"
                                        >
                                            {nutxuly === 1 && (
                                                <div className="spinner-border spinner-border-sm" role="status" />
                                            )}
                                            <div>{idservice === item_account.id ? dasaochep : 'Mua ngay'}</div>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
